import { bl_fi_my_einvoice_consolidated_submission_queue_RowClass } from '../../dbschema/bl_fi_my_einvoice_consolidated_submission_queue.model';
import { BaseContainerModel } from '../base-container.model';

export class ConsolidatedSubmissionQueueContainerModel extends BaseContainerModel {
    bl_fi_my_einvoice_consolidated_submission_queue: bl_fi_my_einvoice_consolidated_submission_queue_RowClass = new bl_fi_my_einvoice_consolidated_submission_queue_RowClass();
}
